import {useMutation} from "@apollo/client";
import {MutationBulkDomainNonPaymentBlockingArgs, NonPaymentBlockingType} from "@/api";
import DataSource from "./DataSource";
import {useState} from "react";
import {createInitialData} from "./initialData";
import {HookClass, useHookClass} from "@dvrt/graphql-widgets";
import equal from "fast-deep-equal";
import {
    BulkDomainNonPaymentBlockingMutation,
    BulkDomainNonPaymentBlockingMutationVariables,
    BulkDomainNonPaymentBlockingDocument,
} from "@/components/domain_settings/bulk_non_payment_blocking/mutations.generated";

type Data = {
    id: number;
    value: NonPaymentBlockingType;
};

export default class DomainBulkNonPaymentBlockingForm extends HookClass {
    private id: number;
    dataSource: DataSource;
    values: Data;
    mutation: any;
    protected mutate: any;
    private setValues: (data: Data) => void;

    useHooks(id: number) {
        this.id = id;
        this.dataSource = useHookClass(DataSource, id);
        this.mutation = BulkDomainNonPaymentBlockingDocument;
        [this.values, this.setValues] = useState(this.initialData);
        [this.mutate] = useMutation<
            BulkDomainNonPaymentBlockingMutation,
            BulkDomainNonPaymentBlockingMutationVariables
        >(this.mutation);
    }

    get initialData(): Data {
        return createInitialData(this.id);
    }

    async submit(): Promise<boolean> {
        const res = await this.mutate({variables: this.filteredVariables});

        if (res.data) {
            this.setValues(this.initialData);
            return true;
        }
        return false;
    }

    protected get filteredVariables(): any {
        return {...this.values};
    }

    updateValues(data: Partial<MutationBulkDomainNonPaymentBlockingArgs>) {
        const newData = {...this.values, ...data};
        this.setValues(newData);
    }

    reset() {
        this.setValues(this.initialData);
    }

    get hasChanged(): boolean {
        return !equal(this.initialData, this.values);
    }
}
